import React from 'react';

interface MultiLineCopyProps {
  text: string;
  className?: string;
  lineClassName?: string;
}

const MultiLineCopy: React.FC<MultiLineCopyProps> = ({ 
  text, 
  className = '', 
  lineClassName = '' 
}) => {
  return (
    <div className={className}>
      {text.split('\n').map((line: string, index: number) => (
        <React.Fragment key={index}>
          {index > 0 && <br />}
          <span className={lineClassName}>{line}</span>
        </React.Fragment>
      ))}
    </div>
  );
};

export default MultiLineCopy;
